/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-07 14:22:33
 * @FilePath: \ui\src\pages\RagPage\components\CodeInfo\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from 'react'
import { useStyles } from '../../style'
import { getRags } from '../../../../api/rag'
import { Button, Tooltip, Modal } from 'antd'
import ModelSelect from '../../../components/ModelSelect'

import KBImg from '@/assets/icon/AI／icon／base.png'

type ChildProps = {
  selectedRag: string
  setSelectedRag: React.Dispatch<React.SetStateAction<string>>
}

// 知识库按钮组件（用于小屏幕）
export const KBButton: React.FC<ChildProps> = ({
  selectedRag,
  setSelectedRag,
}) => {
  const { styles } = useStyles()
  const [ragList, setRagList] = useState<any[]>([])
  const [modalVisible, setModalVisible] = useState(false)

  useEffect(() => {
    getRags().then((res: any) => {
      setRagList(res.data)
    })
  }, [])

  const selectedRagItem = ragList.find((item) => item.ragTag === selectedRag)

  const renderKBContent = () => (
    <>
      <div className={styles.KBHeader}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={KBImg}
            alt="知识库"
            style={{ width: '28px', marginRight: '8px' }}
          />
          <span>知识库</span>
        </div>
      </div>

      <div className={styles.KBInfo}>
        {ragList.length > 0 &&
          ragList.map((item: any) => (
            <Tooltip key={item.ragTag} title={item.ragDesc}>
              <div
                className={styles.KBStepItem}
                style={{
                  background: selectedRag == item.ragTag ? '#F1F2F5' : '',
                }}
                onClick={() => {
                  setSelectedRag(item.ragTag)
                  setModalVisible(false)
                }}
              >
                <div className={styles.KBStepItemImg}>
                  <img
                    src={item.extConfig.iconUrl}
                    alt="变频器图标"
                    style={{ width: '56px', height: '56px' }}
                  />
                </div>
                <div className={styles.KBTitleText}>
                  <div className={styles.KBStepTitle}>
                    {item.ragName?.includes('HOPE')
                      ? item.ragName.replace('HOPE', 'Hope')
                      : item.ragName}
                  </div>
                  <div className={styles.KBStepDesc}>
                    {item.ragDesc?.length > 30
                      ? item.ragDesc?.slice(0, 30) + '...'
                      : item.ragDesc}
                  </div>
                </div>
              </div>
            </Tooltip>
          ))}
      </div>
    </>
  )

  return (
    <>
      <Button
        type="default"
        onClick={() => setModalVisible(true)}
        style={{
          display: 'flex',
          alignItems: 'center',
          margin: '6px 0',
        }}
      >
        <img
          src={selectedRagItem?.extConfig?.iconUrl || KBImg}
          alt="知识库"
          style={{ width: '24px', height: '24px' }}
        />
        <span>
          {selectedRagItem
            ? selectedRagItem.ragName?.includes('HOPE')
              ? selectedRagItem.ragName.replace('HOPE', 'Hope')
              : selectedRagItem.ragName
            : '选择知识库'}
        </span>
      </Button>
      <Modal
        title="选择知识库"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={600}
        style={{ top: 50 }}
      >
        <div
          className={`${styles.KBContainer} ${styles.card}`}
          style={{
            border: 'none',
            boxShadow: 'none',
            height: 'auto',
            maxHeight: '70vh',
            overflow: 'auto',
          }}
        >
          {renderKBContent()}
        </div>
      </Modal>
    </>
  )
}

const KBList: React.FC<ChildProps> = ({ selectedRag, setSelectedRag }) => {
  const { styles } = useStyles()
  const [ragList, setRagList] = useState<any[]>([])
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  useEffect(() => {
    getRags().then((res: any) => {
      setRagList(res.data)
    })
  }, [])

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 1080)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => {
      window.removeEventListener('resize', checkScreenSize)
    }
  }, [])

  // 小屏幕时不显示在左侧
  if (isSmallScreen) {
    return null
  }

  return (
    <div className={`${styles.KBContainer} ${styles.card}`}>
      <div className={styles.KBHeader}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={KBImg}
            alt="知识库"
            style={{ width: '28px', marginRight: '8px' }}
          />
          <span>知识库</span>
        </div>
        <ModelSelect />
      </div>

      <div className={styles.KBInfo}>
        {ragList.length > 0 &&
          ragList.map((item: any) => (
            <Tooltip key={item.ragTag} title={item.ragDesc}>
              <div
                className={styles.KBStepItem}
                style={{
                  background: selectedRag == item.ragTag ? '#F1F2F5' : '',
                }}
                onClick={() => {
                  setSelectedRag(item.ragTag)
                }}
              >
                <div className={styles.KBStepItemImg}>
                  <img
                    src={item.extConfig.iconUrl}
                    alt="变频器图标"
                    style={{ width: '56px', height: '56px' }}
                  />
                </div>
                <div className={styles.KBTitleText}>
                  <div className={styles.KBStepTitle}>
                    {item.ragName?.includes('HOPE')
                      ? item.ragName.replace('HOPE', 'Hope')
                      : item.ragName}
                  </div>
                  <div className={styles.KBStepDesc}>
                    {item.ragDesc?.length > 30
                      ? item.ragDesc?.slice(0, 30) + '...'
                      : item.ragDesc}
                  </div>
                </div>
              </div>
            </Tooltip>
          ))}
      </div>
    </div>
  )
}

export default KBList
